import i18n from '@/plugins/i18n';
import utils from '@/utils/functions';
import store from '@/state/store';

export const staticData = () => {
  store.state.companySettings;
  const shouldHideCpa = utils.checkOcultarCpa();

  const baseColumns = [
    {
      key: 'level3_name',
      label: `${i18n.t('Name')} (L3)`
    },
    {
      key: 'level2_name',
      label: `${i18n.t('Name')} (L2)`
    },
    {
      key: 'level1_name',
      label: `${i18n.t('Name')} (L1)`
    },
    {
      key: 'affiliate_name',
      label: i18n.t('Affiliate')
    },
    {
      key: 'reward_mark_count',
      label: i18n.t('Qty. CPA'),
      custom_class: 'text-right',
      formatter: utils.formatIntOnlyNumber
    },
    {
      key: 'reward_mark',
      label: 'CPA',
      custom_class: 'text-right',
      formatter: utils.formatMoneyFloat
    },
    {
      key: 'reward_accumulative',
      label: i18n.t('Reward'),
      custom_class: 'text-right',
      formatter: utils.formatMoneyFloat
    },
    {
      key: 'reward_total',
      label: i18n.t('Reward Total'),
      custom_class: 'text-right',
      formatter: utils.formatMoneyFloat
    },
    {
      key: 'gross_value',
      label: i18n.t('Gross Value'),
      custom_class: 'text-right',
      formatter: utils.formatMoneyFloat
    },
    {
      key: 'final_gross_value',
      label: i18n.t('Final Gross Value'),
      custom_class: 'text-right',
      formatter: utils.formatMoneyFloat
    },
    {
      key: 'partner_reward',
      label: i18n.t('Partner Reward'),
      custom_class: 'text-right',
      formatter: utils.formatMoneyFloat
    }
  ];

  if (!shouldHideCpa) {
    baseColumns.push(
      {
        key: 'reward_mark_count',
        label: i18n.t('Qty. CPA'),
        custom_class: 'text-right',
        formatter: utils.formatIntOnlyNumber
      },
      {
        key: 'reward_mark',
        label: 'CPA',
        custom_class: 'text-right',
        formatter: utils.formatMoneyFloat
      }
    );
  }

  return {
    columns: baseColumns,
    affiliateColumns() {
      let cols = [
        {
          key: 'a_name',
          label: i18n.t('Name')
        },
        {
          key: 'sub_brand_name',
          label: i18n.t('Sub Brand')
        },
        {
          key: 'pl1_name',
          label: i18n.t('Partner Level') + ' (N1)'
        },
        {
          key: 'pl2_name',
          label: i18n.t('Partner Level') + ' (N2)'
        },
        {
          key: 'pl3_name',
          label: i18n.t('Partner Level') + ' (N3)'
        },
        {
          key: 'turnover',
          label: i18n.t('Turnover'),
          formatter: utils.formatMoneyFloat,
          custom_class: 'text-center'
        },
        {
          key: 'payout',
          label: i18n.t('Payout'),
          formatter: utils.formatMoneyFloat,
          custom_class: 'text-center'
        },
        {
          key: 'ggr',
          label: 'GGR',
          formatter: utils.formatMoneyFloat,
          custom_class: 'text-center'
        },
        {
          key: 'ngr',
          label: 'NGR',
          formatter: utils.formatMoneyFloat,
          custom_class: 'text-center'
        },
        {
          key: 'admin_fee',
          label: i18n.t('Adm. Fee'),
          formatter: utils.formatMoneyFloat,
          custom_class: 'text-center'
        },
        {
          key: 'reward_accumulative',
          label: i18n.t('Total Reward Affiliate'),
          custom_class: 'text-right',
          formatter: utils.formatMoneyFloat
        }
      ];

      if (!shouldHideCpa) {
        cols.push(
          {
            key: 'reward_mark_count',
            label: i18n.t('Qty. CPA'),
            custom_class: 'text-right',
            formatter: utils.formatIntOnlyNumber
          },
          {
            key: 'reward_mark',
            label: 'CPA',
            custom_class: 'text-right',
            formatter: utils.formatMoneyFloat
          }
        );
      }

      // exibe apenas nível atual e abaixo nas colunas
      // ex: login com nível 1, oculta colunas n2 e n3
      if (store?.state?.partnerAccess?.id) {
        let partner = store?.state?.partnerAccess;
        switch (partner.level) {
          case 1:
            cols = cols.filter((c) => c.key != 'pl3_name');
            cols = cols.filter((c) => c.key != 'pl2_name');
            break;
          case 2:
            cols = cols.filter((c) => c.key != 'pl3_name');
            break;
        }
      }

      return cols;
    }
  };
};

export default staticData;
